const installmentPlaceholder = '<div class="rebuy-cart__flyout-installments-native-placeholder placeholder-animation"></div>';

window.RebuyUtils = {
    init() {
        document.addEventListener('rebuy:smartcart.ready', () => {
            window.RebuyUtils.initInstallments();
        });

        document.addEventListener('rebuy:cart.change', (event) => {
            window.RebuyUtils.initInstallments();
        });
    },

    async initInstallments() {
        const el = document.querySelector('[data-rebuy-installments-native]');
        if (!el) {
            return;
        }

        el.style.setProperty('--height', `${el.offsetHeight}px`);
        el.innerHTML = installmentPlaceholder;

        try {
            const response = await fetch('/cart?section_id=cart-installments').then(res => res.text());
            const dom = new DOMParser().parseFromString(response, 'text/html');
            const html = dom.querySelector('.shopify-section');
            el.innerHTML = (html?.innerHTML || '');
        } catch (error) {
            console.error(error);
        }
    },
}

window.RebuyUtils.init();